import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import { fetchSigningKeys } from '../feedback-linking.utils';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false, vendorUuid } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }
            if (!vendorUuid) {
                throw new Error('No vendorUuid Given');
            }
            commit('setFetching', { fetching: true });
            try {
                const { data: signingKeys } = await fetchSigningKeys({ vendorUuid });
                each(signingKeys, (key) => {
                    key.revoked = key.revoked.toString();
                });
                commit('setMap', {
                    map: Object.freeze(keyBy(signingKeys, (key) => key.key_value)),
                });
            } catch (fetchingError) {
                commit('setError', { error: fetchingError });
            }
            commit('setFetching', { fetching: false });
        },
    },
    getters: {
        list: (state) => values(state.map),
        keyByValue: (state) => (value) => state.map[value],
    },
};
